import React, { useEffect, useState } from 'react';
import { loadable } from '@shared/core/loadableFromNamedExport';
import type { PhotoUploaderProps, PhotoUploaderWithPollingProps } from './PhotoUploader.types';
import { usePreloadTranslationNamespaces } from '@shared/hooks/usePreloadTranslationNamespaces';

const LazyPhotoUploaderInner = loadable(() => import(/* webpackChunkName: "admin/PhotoUploader" */ './PhotoUploader'), 'PhotoUploader');

const LazyPhotoUploaderWithoutPollingInner = loadable(() => import(/* webpackChunkName: "admin/PhotoUploader" */ './PhotoUploader'), 'PhotoUploaderWithoutPolling');

export const PhotoUploader = (props: PhotoUploaderWithPollingProps) => {
  const [isInitialized, setIsInitialized] = useState(false);

  usePreloadTranslationNamespaces('photoUploader', 'photoPickerDialog', 'multiPhotoSelector');

  useEffect(() => {
    if (props.isOpenPickerDialog) {
      setIsInitialized(true);
    }
  }, [props.isOpenPickerDialog]);

  if (!isInitialized) {
    return null;
  }

  return <LazyPhotoUploaderInner {...props} />;
};

export const PhotoUploaderWithoutPolling = (props: PhotoUploaderProps) => {
  const [isInitialized, setIsInitialized] = useState(false);

  usePreloadTranslationNamespaces('photoUploader', 'photoPickerDialog', 'multiPhotoSelector');

  useEffect(() => {
    if (props.isOpenPickerDialog) {
      setIsInitialized(true);
    }
  }, [props.isOpenPickerDialog]);

  if (!isInitialized) {
    return null;
  }

  return <LazyPhotoUploaderWithoutPollingInner {...props} />;
};
